<template>
    <div id="information_tooltip">
        <v-tooltip 
            top
            content-class="information-tooltip"    
        >
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="white"
                >
                    icon-about
                </v-icon>
            </template>
            <div class="information-tooltip__container">
                <div v-for="(item, index) in information" :key="`${id}_${index}`">
                    <div v-show="item.title"
                        class="information-tooltip__title"
                    >
                        {{ item.title }}
                    </div>
                    <div v-show="item.content"
                        class="information-tooltip__content"
                    >
                        {{ item.content }}
                    </div>
                </div>
            </div>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    name: 'information_tooltip',
    
    props: {
        id: {
            type: String,
            require: true
        },

        information: {
            type: Array,
            require: true,
        }
    }
}
</script>

<style lang="scss" scoped>
    #information_tooltip {
        margin-top: 4px;
    }

    .information-tooltip {
        width: 15vw;
        color: #121624;
        padding: 8px;
        border-radius: 4px;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.4);
        opacity: 1 !important;
        background: #ffffff;

        &__container {
            font-size: 14px;
            line-height: 1.43;
        }

        &__title {
            font-weight: bold;
            letter-spacing: 0.5px;
        }

        &__content {
            letter-spacing: 0.6px;
        }
    }
</style>